<app-header></app-header>

<div class="my-account container">
  <div class="my-account__heading">
    <div>
      <h1>{{'marketplace.account.title'|transloco}}</h1>
      <p class="my-account__subtitle">
        {{'marketplace.account.subtitle'|transloco}}
      </p>
    </div>
  </div>

  <app-account-tabs class="my-account__tabs"></app-account-tabs>

  <section id="incoming-bookings">
    <h2>{{'marketplace.account.bookings.incoming.title'|transloco}}</h2>

    <div class="bookings__list">
      @if (incomingBookings) {
        @for (booking of incomingBookings; track booking) {
          <app-booking-list-item
            [booking]="booking"
          ></app-booking-list-item>
        }
        @if (incomingBookings.length === 0) {
          <div class="empty-state">
            <i class="empty-state__icon fa-solid fa-camera-retro"></i>
            <h3>{{'marketplace.account.bookings.incoming.empty-state.title'|transloco}}</h3>
            <a class="button"
              [routerLink]="['/marketplace']"
              >
              {{'marketplace.account.bookings.incoming.empty-state.label'|transloco}}
              <i class="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        }
      }
      @if (!incomingBookings) {
        @for (_ of [0, 1, 2]; track _) {
          <app-booking-list-item
          ></app-booking-list-item>
        }
      }
    </div>
  </section>

  @if (!pastBookings || pastBookings.length > 0) {
    <section id="past-bookings">
      <h2>{{'marketplace.account.bookings.past.title'|transloco}}</h2>
      <div class="bookings__list">
        @if (pastBookings) {
          @for (booking of pastBookings; track booking) {
            <app-booking-list-item
              [booking]="booking"
            ></app-booking-list-item>
          }
        }
        @if (!pastBookings) {
          @for (_ of [0, 1, 2]; track _) {
            <app-booking-list-item
            ></app-booking-list-item>
          }
        }
      </div>
    </section>
  }
</div>
